import { Box, Link, Typography } from '@mui/material';
import config from 'config';
import isProd from '../../utils/isProd';

const EnvironmentBanner = () => {
  const prefix = config.ADMIN_API_URL.includes('dev') ? 'DEV' : 'STAGE';

  if (isProd()) return null;

  return (
      <Box sx={{width: '100%', px: 3, py: 1, mb: 0, zIndex: 100}}>
        <Typography
          variant="body2"
          sx={{ background: 'rgba(188,29,29,0.88)', width: '100%', p: 1, color: 'white', fontWeight: '400', textAlign: 'center', borderRadius: 1 }}
        >
          This is the {prefix} environment used for development purposes. To work with the stable version and real data,
          please use{' '}
          <Link sx={{ color: 'white', textDecorationColor: 'white' }} href="https://wellspy-admin.asqq.io/" target="_blank">
            PRODUCTION
          </Link>
        </Typography>
      </Box>
  );
};

export default EnvironmentBanner;
